/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CustomerStatus {
    DRAFT = 'Draft',
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
}
